export default "__VITE_ASSET__29a7a051__"